import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import './FichajeGPS.css';

// ===== FUNCIONES SEGURAS LOCALSTORAGE =====
function safeGetItem(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}
function safeSetItem(key, value) {
  try { localStorage.setItem(key, value); } catch {}
}

const DIAS_SEMANA = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const DIAS_SEMANA_CORTO = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

function getGreeting() {
  const h = new Date().getHours();
  if (h >= 6 && h < 14) return 'Buenos días';
  if (h >= 14 && h < 21) return 'Buenas tardes';
  return 'Buenas noches';
}

function getInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}

function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return `${h}h ${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
}

function formatTimeShort(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m.toString().padStart(2, '0')}m`;
}

function formatDateFull() {
  const now = new Date();
  const dia = DIAS_SEMANA[now.getDay()];
  const num = now.getDate();
  const mes = MESES[now.getMonth()];
  const year = now.getFullYear();
  return `Hoy, ${dia.toLowerCase()}, ${num} de ${mes} de ${year}`;
}

// ===== DETECCION DE PLATAFORMA =====
function detectPlatform() {
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|SamsungBrowser|Brave/i.test(ua);
  const isChrome = /Chrome|CriOS/i.test(ua) && !/EdgiOS|Edge|Edg|OPR|Opera|Brave|SamsungBrowser|DuckDuckGo/i.test(ua);
  const isFirefox = /Firefox|FxiOS/i.test(ua);
  const isDuckDuckGo = /DuckDuckGo/i.test(ua);
  const isSamsung = /SamsungBrowser/i.test(ua);
  const isOpera = /OPR|Opera|OPiOS/i.test(ua);
  const isEdge = /Edg|EdgiOS|Edge/i.test(ua);
  const isBrave = /Brave/i.test(ua);
  const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  // Nombre legible del navegador
  let browserName = 'tu navegador';
  if (isDuckDuckGo) browserName = 'DuckDuckGo';
  else if (isBrave) browserName = 'Brave';
  else if (isEdge) browserName = 'Edge';
  else if (isOpera) browserName = 'Opera';
  else if (isSamsung) browserName = 'Samsung Internet';
  else if (isFirefox) browserName = 'Firefox';
  else if (isChrome) browserName = 'Chrome';
  else if (isSafari) browserName = 'Safari';

  return { isIOS, isAndroid, isSafari, isChrome, isFirefox, isDuckDuckGo, isSamsung, isOpera, isEdge, isBrave, isPWA, browserName };
}

// ===== ABRIR AJUSTES DEL DISPOSITIVO/NAVEGADOR =====
function abrirAjustesUbicacion(platform) {
  // Helper: intentar abrir URL con múltiples métodos
  function tryOpenUrl(url) {
    // Método 1: crear un <a> invisible y hacer click programático (más fiable en móvil)
    try {
      const a = document.createElement('a');
      a.href = url;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => document.body.removeChild(a), 100);
      return true;
    } catch(e) {}
    // Método 2: window.open
    try {
      const win = window.open(url, '_system');
      if (win) return true;
    } catch(e) {}
    // Método 3: location.href (último recurso)
    try {
      window.location.href = url;
      return true;
    } catch(e) {}
    return false;
  }

  // iOS: app-settings: abre los ajustes de la app actual (el navegador)
  if (platform.isIOS) {
    // app-settings: funciona en iOS 8+ para abrir la configuración de la app actual
    return tryOpenUrl('app-settings:');
  }

  // Android: intent:// para abrir ajustes de ubicación del sistema
  if (platform.isAndroid) {
    // Cada navegador puede necesitar un intent diferente
    const intents = [];

    // Para Chrome/Brave/Edge: abrir ajustes de ubicación del sistema
    if (platform.isChrome || platform.isBrave || platform.isEdge) {
      intents.push('intent:#Intent;action=android.settings.LOCATION_SOURCE_SETTINGS;end');
    }
    // Samsung Internet: ajustes de la app del navegador
    if (platform.isSamsung) {
      intents.push('intent:#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;data=package:com.sec.android.app.sbrowser;end');
    }
    // DuckDuckGo
    if (platform.isDuckDuckGo) {
      intents.push('intent:#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;data=package:com.duckduckgo.mobile.android;end');
    }
    // Fallback genérico: ajustes de ubicación del sistema
    intents.push('intent:#Intent;action=android.settings.LOCATION_SOURCE_SETTINGS;end');

    // Intentar cada intent en orden
    for (const intentUrl of intents) {
      if (tryOpenUrl(intentUrl)) return true;
    }
    return false;
  }

  // Desktop: no se puede abrir ajustes, devolver false
  return false;
}

export default function FichajeGPS({
  dni, nombre, departamento, empresa, backendUrl,
  tipo, setTipo, setNombre, setDepartamento,
  setEmpresa,
  setMensaje: setMensajeParent, setAdvertencia: setAdvertenciaParent,
  setFicharTrigger, ficharTrigger,
  onInvalidUserSession,
  darkMode, setDarkMode,
  fichajeMode = 'gps',
  onQrScan,
  qrScanning = false,
  qrMensaje = '',
  qrAdvertencia = ''
}) {
  const isQrMode = fichajeMode === 'qr';
  const [activeSection, setActiveSection] = useState('inicio');
  const [dashboard, setDashboard] = useState(null);
  const [trabajando, setTrabajando] = useState(false);
  const [tiempoHoy, setTiempoHoy] = useState(0);
  const [jornadaHoras, setJornadaHoras] = useState(8);
  const [geoFichando, setGeoFichando] = useState(false);
  const [geoMensaje, setGeoMensaje] = useState('');
  const [selectedDay, setSelectedDay] = useState(null);
  const [calYear, setCalYear] = useState(new Date().getFullYear());
  const [calMonth, setCalMonth] = useState(new Date().getMonth() + 1);
  const [turnoHoy, setTurnoHoy] = useState(null); // Letra: M, T, N...
  const [turnoNombre, setTurnoNombre] = useState(null); // Nombre: Mañana, Tarde...
  const [lastFicharTime, setLastFicharTime] = useState(null); // Timestamp último fichaje exitoso
  const [cooldownRemaining, setCooldownRemaining] = useState(0); // Segundos restantes para poder fichar
  const [geoPermiso, setGeoPermiso] = useState('unknown'); // 'granted','denied','prompt','unknown'
  const [showGeoModal, setShowGeoModal] = useState(false); // Modal pre-permiso
  const [showGeoDeniedModal, setShowGeoDeniedModal] = useState(false); // Modal permiso denegado
  const [geoModalStep, setGeoModalStep] = useState('ask'); // 'ask','requesting','error'
  // ===== ONBOARDING GPS =====
  const [gpsOnboardingStep, setGpsOnboardingStep] = useState(() => {
    return fichajeMode === 'gps' && safeGetItem('gps_onboarding_done') !== 'true' ? 1 : 0;
  });
  const [gpsOnboardingChecked, setGpsOnboardingChecked] = useState(false);
  const timerRef = useRef(null);
  const platform = useRef(detectPlatform()).current;
  const reminderTimersRef = useRef([]);
  const reminderSentRef = useRef(new Set());
  const notifRequestDoneRef = useRef(false);

  const invalidateUserSession = useCallback((message) => {
    if (typeof onInvalidUserSession === 'function') {
      onInvalidUserSession(message || 'Tu usuario ya no es válido. Inicia sesión de nuevo.');
      return;
    }
    if (setMensajeParent) {
      setMensajeParent(message || 'Tu usuario ya no es válido. Inicia sesión de nuevo.');
    }
  }, [onInvalidUserSession, setMensajeParent]);

  // Toggle dark/light mode
  const toggleTheme = () => {
    setDarkMode(prev => {
      safeSetItem('gps_dark_mode', String(!prev));
      return !prev;
    });
  };

  const clearReminderTimers = useCallback(() => {
    reminderTimersRef.current.forEach(id => clearTimeout(id));
    reminderTimersRef.current = [];
  }, []);

  const parseTodayTime = (value) => {
    if (!value || typeof value !== 'string') return null;
    const parts = value.split(':');
    if (parts.length < 2) return null;
    const hh = parseInt(parts[0], 10);
    const mm = parseInt(parts[1], 10);
    if (Number.isNaN(hh) || Number.isNaN(mm)) return null;

    const dt = new Date();
    dt.setHours(hh, mm, 0, 0);
    return dt;
  };

  const showWorkReminder = useCallback(async ({ title, body, tag }) => {
    if (typeof window === 'undefined' || !('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;

    const payload = {
      type: 'SHOW_NOTIFICATION',
      title,
      body,
      tag,
      data: { url: window.location.pathname || '/' }
    };

    try {
      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.ready;
        if (reg && reg.active) {
          reg.active.postMessage(payload);
          return;
        }
        if (reg && reg.showNotification) {
          await reg.showNotification(title, {
            body,
            tag,
            renotify: true,
            icon: '/logo192.png',
            badge: '/logo192.png',
            data: { url: window.location.pathname || '/' }
          });
          return;
        }
      }
      new Notification(title, { body, tag });
    } catch (_) {}
  }, []);

  const scheduleReminderForTarget = useCallback((targetDate, baseTag, labelText) => {
    if (!targetDate) return;
    const now = Date.now();
    const targetMs = targetDate.getTime();
    if (targetMs <= now) return;

    // Recordatorios: justo al completar (0 min) y 5 min después (-5)
    [0, -5].forEach((minutesOffset) => {
      const notifyAt = targetMs + (minutesOffset * 60 * 1000);
      const key = `${baseTag}-${minutesOffset}-${new Date(targetMs).toDateString()}`;
      if (reminderSentRef.current.has(key)) return;

      const trigger = () => {
        if (reminderSentRef.current.has(key)) return;
        reminderSentRef.current.add(key);
        
        // Mensajes diferentes según si es al completar o después
        let titulo, cuerpo;
        if (minutesOffset === 0) {
          titulo = '✅ Jornada completada';
          cuerpo = `¡Completaste tu jornada! Ya puedes fichar salida.`;
        } else {
          titulo = '✅ Jornada completada';
          cuerpo = `Ya pasaron 5 minutos. Recuerda fichar salida cuando termines.`;
        }
        
        showWorkReminder({
          title: titulo,
          body: cuerpo,
          tag: key
        });
      };

      const delay = notifyAt - now;
      if (delay <= 0) {
        if (targetMs - now > 0) trigger();
        return;
      }

      const id = setTimeout(trigger, delay);
      reminderTimersRef.current.push(id);
    });
  }, [showWorkReminder]);

  // Check GPS permission state on mount (WITHOUT triggering a prompt)
  useEffect(() => {
    if (isQrMode) {
      setGeoPermiso('unknown');
      return;
    }
    // Only use permissions API to check state silently - don't trigger prompt
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        setGeoPermiso(result.state);
        result.onchange = () => setGeoPermiso(result.state);
      }).catch(() => {
        // iOS Safari doesn't support permissions API, keep 'unknown'
        setGeoPermiso('unknown');
      });
    } else {
      // No permissions API (iOS Safari) - we'll discover on first use
      setGeoPermiso('unknown');
    }
  }, [isQrMode]);

  // ===== WEB PUSH: suscribir al empleado para recibir recordatorios del servidor =====
  useEffect(() => {
    if (!dni || !backendUrl || !('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const subscribeToWebPush = async () => {
      try {
        // 1. Obtener clave pública VAPID del backend
        const resp = await axios.get(`${backendUrl}/api/push/vapid-public-key`, { withCredentials: true });
        if (resp.data?.status !== 'ok' || !resp.data.publicKey) return;

        const vapidPublicKey = resp.data.publicKey;

        // 2. Esperar a que el Service Worker esté listo
        const registration = await navigator.serviceWorker.ready;

        // 3. Verificar si ya está suscrito
        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
          // 4. Pedir permiso de notificación si no se ha hecho
          if (Notification.permission === 'default') {
            const perm = await Notification.requestPermission();
            if (perm !== 'granted') return;
          }
          if (Notification.permission !== 'granted') return;

          // 5. Suscribirse a Web Push
          // Convertir la clave VAPID de base64url a Uint8Array
          const padding = '='.repeat((4 - (vapidPublicKey.length % 4)) % 4);
          const base64 = (vapidPublicKey + padding).replace(/-/g, '+').replace(/_/g, '/');
          const rawData = window.atob(base64);
          const outputArray = new Uint8Array(rawData.length);
          for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
          }

          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: outputArray
          });
        }

        // 6. Enviar suscripción al backend
        const subJson = subscription.toJSON();
        await axios.post(`${backendUrl}/api/push/subscribe`, {
          dni: dni,
          empresa: empresa || safeGetItem('empresa') || '',
          subscription: {
            endpoint: subJson.endpoint,
            keys: {
              p256dh: subJson.keys.p256dh,
              auth: subJson.keys.auth
            }
          },
          user_agent: navigator.userAgent
        }, { withCredentials: true });

      } catch (err) {
        console.warn('[Push] Error suscribiendo a Web Push:', err.message);
      }
    };

    // Delay 5 seconds to not block initial load
    const timeout = setTimeout(subscribeToWebPush, 5000);
    return () => clearTimeout(timeout);
  }, [dni, backendUrl, empresa]);

  // Helper: request geolocation permission via the browser
  // IMPORTANTE: Cierra el modal ANTES de pedir permiso para que el prompt nativo
  // del navegador ("Permitir/Denegar") sea visible y no quede tapado.
  const solicitarPermisoGeo = () => {
    if (!navigator.geolocation) {
      setGeoModalStep('error');
      return;
    }

    // 1) Cerrar el modal para que el diálogo nativo del navegador se vea
    setShowGeoModal(false);
    setGeoModalStep('ask');

    // 2) Mostrar indicador inline mientras se espera
    setGeoFichando(true);
    setGeoMensaje('Esperando permiso de ubicación...');

    // 3) Pedir geolocalización (esto dispara el prompt nativo del navegador)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // Permiso concedido + posición obtenida
        setGeoPermiso('granted');
        setGeoMensaje('Ubicación obtenida. Registrando fichaje...');
        procesarFichaje(position);
      },
      (error) => {
        setGeoFichando(false);
        if (error.code === error.PERMISSION_DENIED) {
          setGeoPermiso('denied');
          setGeoMensaje('');
          // Mostrar instrucciones de cómo activarlo
          setShowGeoDeniedModal(true);
        } else if (error.code === error.TIMEOUT) {
          setGeoMensaje('⏱️ Tiempo de espera agotado. Activa el GPS y reintenta.');
        } else {
          setGeoMensaje('❌ No se pudo obtener la ubicación: ' + error.message);
        }
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  };

  // Fetch dashboard data
  const validateCurrentUser = useCallback(async () => {
    const currentDni = dni || safeGetItem('dni');
    if (!currentDni || !backendUrl) return false;
    try {
      const res = await axios.get(`${backendUrl}/api/usuario_info`, {
        params: { dni: currentDni },
        withCredentials: true
      });
      if (res.data && typeof res.data === 'object' && (res.data.nombre || res.data.departamento)) {
        if (res.data.nombre) {
          setNombre(res.data.nombre);
          safeSetItem('nombre', res.data.nombre);
        }
        if (res.data.departamento) {
          setDepartamento(res.data.departamento);
          safeSetItem('departamento', res.data.departamento);
        }
        if (res.data.empresa) {
          if (setEmpresa) setEmpresa(res.data.empresa);
          safeSetItem('empresa', res.data.empresa);
        }
        if (res.data.dni) {
          safeSetItem('dni', res.data.dni);
        }
        return true;
      }
      invalidateUserSession('Tu usuario ha sido eliminado. Contacta con el administrador.');
      return false;
    } catch (e) {
      if (e.response?.status === 401 || e.response?.status === 404) {
        invalidateUserSession('Tu usuario ya no es válido. Inicia sesión de nuevo.');
        return false;
      }
      return true;
    }
  }, [dni, backendUrl, setNombre, setDepartamento, setEmpresa, invalidateUserSession]);

  const fetchDashboard = useCallback(async () => {
    if (!dni || !backendUrl) return;
    try {
      const res = await axios.get(`${backendUrl}/api/fichajes/resumen_dashboard`, {
        params: { dni, year: calYear, month: calMonth, empresa: empresa || '' },
        withCredentials: true
      });
      if (res.data && res.data.status === 'ok') {
        setDashboard(res.data);
        setTrabajando(res.data.trabajando);
        setTiempoHoy(res.data.tiempo_total_hoy || 0);
        setJornadaHoras(res.data.jornada_horas || 8);
        setTurnoHoy(res.data.turno_hoy || null);
        setTurnoNombre(res.data.turno_nombre || null);
      }
    } catch (e) {
      if (e.response?.status === 401) {
        invalidateUserSession('Tu usuario ya no es válido. Inicia sesión de nuevo.');
        return;
      }
      console.warn('[GPS Dashboard] Error:', e.message);
    }
  }, [dni, backendUrl, calYear, calMonth, empresa, invalidateUserSession]);

  useEffect(() => {
    validateCurrentUser();
  }, [validateCurrentUser]);

  useEffect(() => { fetchDashboard(); }, [fetchDashboard, ficharTrigger]);

  // Auto-refresh dashboard every 30 seconds to keep data fresh
  useEffect(() => {
    const interval = setInterval(() => {
      fetchDashboard();
    }, 30000);
    return () => clearInterval(interval);
  }, [fetchDashboard]);

  // Recordatorios de salida: 30min y 15min antes de 8h trabajadas o fin de jornada
  useEffect(() => {
    clearReminderTimers();

    if (!trabajando) return;
    if (typeof window === 'undefined' || !('Notification' in window)) return;

    if (Notification.permission === 'default' && !notifRequestDoneRef.current) {
      notifRequestDoneRef.current = true;
      Notification.requestPermission().catch(() => {});
    }

    if (Notification.permission !== 'granted') return;

    const now = Date.now();

    // Objetivo 1: completar horas de jornada acumuladas hoy
    const jornadaObjetivoSeg = Math.max(0, (jornadaHoras * 3600) - (tiempoHoy || 0));
    if (jornadaObjetivoSeg > 0) {
      const objetivo8h = new Date(now + (jornadaObjetivoSeg * 1000));
      scheduleReminderForTarget(objetivo8h, 'rem-8h', 'completar tu jornada');
    }

    // Objetivo 2: fin de jornada por horario (si viene del backend)
    const salidaTurno = parseTodayTime(dashboard?.salida_turno || null);
    if (salidaTurno) {
      scheduleReminderForTarget(salidaTurno, 'rem-fin-turno', 'tu fin de jornada');
    }

    return () => {
      clearReminderTimers();
    };
  }, [
    trabajando,
    tiempoHoy,
    jornadaHoras,
    dashboard?.salida_turno,
    scheduleReminderForTarget,
    clearReminderTimers
  ]);

  // Live timer - increment every second if trabajando
  useEffect(() => {
    if (trabajando) {
      timerRef.current = setInterval(() => {
        setTiempoHoy(prev => prev + 1);
      }, 1000);
    } else {
      if (timerRef.current) clearInterval(timerRef.current);
    }
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [trabajando]);

  // Cooldown timer - 2 minutos entre fichajes
  useEffect(() => {
    if (!lastFicharTime) {
      setCooldownRemaining(0);
      return;
    }
    
    const interval = setInterval(() => {
      const now = Date.now();
      const elapsed = now - lastFicharTime;
      const remaining = Math.max(0, 120000 - elapsed); // 2 minutos = 120000 ms
      setCooldownRemaining(Math.ceil(remaining / 1000)); // Convertir a segundos
      
      if (remaining <= 0) {
        setCooldownRemaining(0);
        clearInterval(interval);
      }
    }, 100); // Actualizar cada 100ms para precisión
    
    return () => clearInterval(interval);
  }, [lastFicharTime]);

  // Clock update
  const [clockTime, setClockTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setClockTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // Fichar con GPS
  const ficharConGPS = async () => {
    if (!navigator.geolocation) {
      setGeoMensaje('Tu navegador no soporta geolocalización');
      return;
    }

    // Si permiso denegado explícitamente → mostrar instrucciones directas
    if (geoPermiso === 'denied') {
      setShowGeoDeniedModal(true);
      return;
    }

    // Si permiso desconocido o 'prompt' → mostrar modal informativo
    // (el usuario necesita saber qué va a pasar antes del prompt nativo)
    if (geoPermiso !== 'granted') {
      setShowGeoModal(true);
      return;
    }

    // Permisos ya otorgados → pedir posición directamente
    setGeoFichando(true);
    setGeoMensaje('Obteniendo ubicación...');

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        setGeoMensaje('Ubicación obtenida. Registrando fichaje...');
        await procesarFichaje(pos);
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          setGeoPermiso('denied');
          setShowGeoDeniedModal(true);
          setGeoMensaje('');
        } else if (error.code === error.TIMEOUT) {
          setGeoMensaje('⏱️ Tiempo de espera agotado. Activa el GPS y reintenta.');
        } else {
          setGeoMensaje('❌ Error GPS: ' + error.message);
        }
        setGeoFichando(false);
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  };

  const procesarFichaje = async (position) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;
    const precision = position.coords.accuracy;
    setGeoMensaje(`Ubicación obtenida (±${Math.round(precision)}m). Registrando...`);

    try {
      const isValid = await validateCurrentUser();
      if (!isValid) {
        setGeoFichando(false);
        return;
      }

      const device_user_agent = navigator.userAgent;
      let deviceInfo = {
        userAgent: device_user_agent,
        deviceMemory: navigator.deviceMemory || 'unknown',
        cores: navigator.hardwareConcurrency || 'unknown',
        maxTouchPoints: navigator.maxTouchPoints || 'unknown'
      };
      if (navigator.userAgentData) {
        try {
          let uaData = await navigator.userAgentData.getHighEntropyValues(['model', 'platform', 'platformVersion', 'brands']);
          deviceInfo.model = uaData.model || 'unknown';
          deviceInfo.platform = uaData.platform || 'unknown';
        } catch {}
      }

      const resp = await axios.post(
        `${backendUrl}/api/fichar_geoloc`,
        { dni, latitud: lat, longitud: lng, precision,
          empresa: empresa || safeGetItem('empresa') || '',
          device_user_agent, device_info: JSON.stringify(deviceInfo)
        },
        { withCredentials: true }
      );

      if (resp.data?.nombre) { setNombre(resp.data.nombre); safeSetItem('nombre', resp.data.nombre); }
      if (resp.data?.departamento) { setDepartamento(resp.data.departamento); safeSetItem('departamento', resp.data.departamento); }
      if (resp.data?.empresa) {
        if (setEmpresa) setEmpresa(resp.data.empresa);
        safeSetItem('empresa', resp.data.empresa);
      }

      if (resp.data.status === 'ok') {
        const nuevoTipo = resp.data.tipo === 'entrada' ? 'salida' : 'entrada';
        setTipo(nuevoTipo);
        safeSetItem('tipo', nuevoTipo);

        // Immediately update working status so timer starts
        if (resp.data.tipo === 'entrada') {
          setTrabajando(true);
        } else if (resp.data.tipo === 'salida') {
          setTrabajando(false);
        }

        setGeoMensaje(`✅ ${resp.data.tipo.toUpperCase()} registrada`);

        if (resp.data.advertencia && setAdvertenciaParent) {
          const advertencia = String(resp.data.advertencia || '');
          if (!/zona|distancia|gps|geoloc|fuera de zona/i.test(advertencia)) {
            setAdvertenciaParent(advertencia);
          }
        }

        setFicharTrigger(prev => prev + 1);
        // Set cooldown: no fichar hasta 2 minutos después
        setLastFicharTime(Date.now());
        // Refresh dashboard after delay to get fresh data from DB
        setTimeout(() => fetchDashboard(), 1000);
        setTimeout(() => fetchDashboard(), 3000); // Second refresh for accuracy
      } else {
        setGeoMensaje(resp.data.mensaje || 'Error al fichar por GPS');
      }
    } catch (err) {
      if (err.response?.status === 401) {
        invalidateUserSession('Tu usuario ya no es válido. Inicia sesión de nuevo.');
        setGeoFichando(false);
        return;
      }
      setGeoMensaje('Error: ' + (err.response?.data?.mensaje || err.message));
    }
    setGeoFichando(false);
  };

  // Progress calculation
  const jornadaSegundos = jornadaHoras * 3600;
  const progreso = Math.min(tiempoHoy / jornadaSegundos, 1);
  const cercaFinal = (jornadaSegundos - tiempoHoy) <= 600 && tiempoHoy > 0; // 10 min
  const completado = tiempoHoy >= jornadaSegundos;

  // Calendar helpers
  const diasDelMes = dashboard?.dias_mes || 30;
  const primerDiaSemana = dashboard?.primer_dia_semana ?? 0;
  const limitarHorasVisibles = (horas) => Math.min(Math.max(Number(horas) || 0, 0), 8);
  const calData = {};
  (dashboard?.calendario || []).forEach(d => {
    calData[d.fecha] = { ...d, horas_visibles: limitarHorasVisibles(d.horas) };
  });

  // Week data for chart
  const semanaData = (dashboard?.semana || []).map(d => ({ ...d, horas_visibles: limitarHorasVisibles(d.horas) }));
  const maxHorasSemana = Math.max(8, ...semanaData.map(d => d.horas_visibles));
  const horasMesVisibles = Object.values(calData).reduce((s, d) => s + d.horas_visibles, 0);

  // First name for greeting
  const firstName = nombre ? nombre.split(/\s+/)[0] : '';
  const firstNameCapitalized = firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase() : '';

  // ===== ONBOARDING GPS (pantalla completa antes de usar la app) =====
  if (!isQrMode && gpsOnboardingStep > 0 && gpsOnboardingStep <= 4) {
    const totalSteps = 4;
    const stepDots = [];
    for (let i = 1; i <= totalSteps; i++) {
      stepDots.push(
        <div key={i} className={`gps-onb-dot ${gpsOnboardingStep === i ? 'active' : ''} ${gpsOnboardingStep > i ? 'done' : ''}`} />
      );
    }

    let onbContent = null;

    if (gpsOnboardingStep === 1) {
      onbContent = (
        <div className="gps-onb-slide">
          <div className="gps-onb-icon-big">📍</div>
          <h1 className="gps-onb-title">Nueva App de Fichaje</h1>
          <p className="gps-onb-text">
            ¡Hola{firstNameCapitalized ? `, ${firstNameCapitalized}` : ''}! El sistema de fichaje ha sido actualizado.
          </p>
          <p className="gps-onb-text">
            Ahora puedes fichar directamente <strong>desde tu móvil</strong> sin necesidad de escanear ningún código QR.
          </p>
          <button className="gps-onb-btn" onClick={() => setGpsOnboardingStep(2)}>
            Continuar →
          </button>
        </div>
      );
    } else if (gpsOnboardingStep === 2) {
      onbContent = (
        <div className="gps-onb-slide">
          <div className="gps-onb-icon-big">🔒</div>
          <h1 className="gps-onb-title">¿Cómo funciona?</h1>
          <div className="gps-onb-info-box">
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">📱</span>
              <span>Pulsas el botón <strong>"Fichar"</strong> cuando entres y cuando salgas</span>
            </div>
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">📍</span>
              <span>El GPS <strong>solo se activa en ese momento</strong>, durante unos segundos</span>
            </div>
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">🔋</span>
              <span><strong>No gasta batería</strong> mientras no fichas</span>
            </div>
          </div>
          <p className="gps-onb-text-small">
            Tu ubicación solo se usa para registrar el fichaje. No se rastrea tu posición en ningún otro momento.
          </p>
          <button className="gps-onb-btn" onClick={() => setGpsOnboardingStep(3)}>
            Continuar →
          </button>
        </div>
      );
    } else if (gpsOnboardingStep === 3) {
      onbContent = (
        <div className="gps-onb-slide">
          <div className="gps-onb-icon-big">📊</div>
          <h1 className="gps-onb-title">¿Qué puedes hacer?</h1>
          <div className="gps-onb-info-box">
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">⏱️</span>
              <span>Ver tus <strong>horas trabajadas</strong> en tiempo real</span>
            </div>
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">📅</span>
              <span>Consultar tu <strong>calendario</strong> de fichajes del mes</span>
            </div>
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">📋</span>
              <span>Revisar el <strong>historial</strong> de entradas y salidas</span>
            </div>
            <div className="gps-onb-info-row">
              <span className="gps-onb-info-icon">🔔</span>
              <span>Recibir <strong>recordatorios</strong> si olvidas fichar la salida</span>
            </div>
          </div>
          <button className="gps-onb-btn" onClick={() => setGpsOnboardingStep(4)}>
            Continuar →
          </button>
        </div>
      );
    } else if (gpsOnboardingStep === 4) {
      onbContent = (
        <div className="gps-onb-slide">
          <div className="gps-onb-icon-big">⚠️</div>
          <h1 className="gps-onb-title">¡Antes de Empezar!</h1>
          <p className="gps-onb-text">
            Antes de empezar, confirma que has entendido cómo funciona el nuevo sistema:
          </p>
          <div className="gps-onb-summary">
            <p>• Fichas pulsando un botón desde el móvil</p>
            <p>• El GPS solo se activa al fichar, unos segundos</p>
            <p>• Debes fichar <strong>entrada</strong> y <strong>salida</strong> cada día</p>
            <p>• Puedes consultar tus horas y fichajes en la app</p>
          </div>
          <label className="gps-onb-checkbox-label">
            <input
              type="checkbox"
              checked={gpsOnboardingChecked}
              onChange={(e) => setGpsOnboardingChecked(e.target.checked)}
              className="gps-onb-checkbox"
            />
            <span>He leído y entendido cómo funciona</span>
          </label>
          <button
            className={`gps-onb-btn final ${gpsOnboardingChecked ? '' : 'disabled'}`}
            onClick={() => {
              if (gpsOnboardingChecked) {
                safeSetItem('gps_onboarding_done', 'true');
                setGpsOnboardingStep(0);
              }
            }}
            disabled={!gpsOnboardingChecked}
          >
            Empezar a usar la app
          </button>
        </div>
      );
    }

    return (
      <div className={`gps-dashboard ${darkMode ? 'dark' : 'light'}`}>
        <div className="gps-onboarding-screen">
          <div className="gps-onb-dots">
            {stepDots}
          </div>
          <div className="gps-onb-content">
            {onbContent}
          </div>
          {gpsOnboardingStep > 1 && (
            <button className="gps-onb-back" onClick={() => setGpsOnboardingStep(s => s - 1)}>
              ← Atrás
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`gps-dashboard ${darkMode ? 'dark' : 'light'}`}>

      {/* ===== MODAL: Solicitar permiso de ubicación ===== */}
      {/* Solo muestra pasos informativos. Al pulsar "Dar permiso", se CIERRA
          este modal para que el prompt nativo del navegador sea visible. */}
      {!isQrMode && showGeoModal && (
        <div className="gps-modal-overlay" onClick={() => { setShowGeoModal(false); setGeoModalStep('ask'); }}>
          <div className="gps-modal" onClick={e => e.stopPropagation()}>
            <div className="gps-modal-icon">📍</div>
            <h2 className="gps-modal-title">Permitir acceso a tu ubicación</h2>
            <p className="gps-modal-text">
              Para fichar necesitamos acceder a la ubicación GPS de tu dispositivo.
            </p>
            <div className="gps-modal-steps">
              <div className="gps-modal-step">
                <span className="gps-modal-step-num">1</span>
                <span>Pulsa <strong>"Continuar"</strong> aquí abajo</span>
              </div>
              <div className="gps-modal-step">
                <span className="gps-modal-step-num">2</span>
                <span>
                  {platform.isIOS
                    ? <>Aparecerá un mensaje del navegador, pulsa <strong>"Permitir"</strong></>
                    : <>Aparecerá un mensaje, selecciona <strong>"Mientras se usa la app"</strong> o <strong>"Permitir"</strong></>
                  }
                </span>
              </div>
              <div className="gps-modal-step">
                <span className="gps-modal-step-num">3</span>
                <span>¡Listo! El fichaje se realizará automáticamente</span>
              </div>
            </div>
            {platform.isIOS && (
              <div className="gps-modal-tip">
                <strong>💡 iPhone/iPad:</strong> Asegúrate de que la ubicación esté activada en <em>Ajustes → Privacidad → Localización → {platform.browserName}</em>
              </div>
            )}
            {platform.isAndroid && (
              <div className="gps-modal-tip">
                <strong>💡 Android:</strong> Asegúrate de que el GPS esté activado en tu dispositivo
              </div>
            )}
            <div className="gps-modal-actions">
              <button className="gps-modal-btn primary" onClick={solicitarPermisoGeo}>
                📍 Continuar
              </button>
              <button className="gps-modal-btn secondary" onClick={() => { setShowGeoModal(false); setGeoModalStep('ask'); }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL: Permisos denegados - instrucciones ===== */}
      {!isQrMode && showGeoDeniedModal && (
        <div className="gps-modal-overlay" onClick={() => setShowGeoDeniedModal(false)}>
          <div className="gps-modal" onClick={e => e.stopPropagation()}>
            <div className="gps-modal-icon">🔒</div>
            <h2 className="gps-modal-title">Ubicación bloqueada</h2>
            <p className="gps-modal-text">
              Para fichar necesitas activar la ubicación. Sigue estos pasos:
            </p>

            {/* BOTÓN ABRIR AJUSTES - iOS */}
            {platform.isIOS && (
              <>
                <button className="gps-modal-btn settings-btn" onClick={() => abrirAjustesUbicacion(platform)}>
                  ⚙️ Abrir Ajustes del iPhone
                </button>
                <div className="gps-modal-instructions">
                  <h3>📱 iPhone/iPad ({platform.browserName}):</h3>
                  <ol>
                    <li>Al pulsar el botón se abrirán los <strong>Ajustes</strong></li>
                    <li>Ve a <strong>Privacidad y seguridad</strong> → <strong>Localización</strong></li>
                    <li>Busca <strong>{platform.browserName}</strong> en la lista</li>
                    <li>Selecciona <strong>"Mientras se usa la app"</strong></li>
                    <li>Vuelve aquí y pulsa <strong>"Reintentar"</strong></li>
                  </ol>
                </div>
              </>
            )}

            {/* BOTÓN ABRIR AJUSTES - Android */}
            {platform.isAndroid && (
              <>
                <button className="gps-modal-btn settings-btn" onClick={() => abrirAjustesUbicacion(platform)}>
                  ⚙️ Abrir Ajustes de Ubicación
                </button>
                <div className="gps-modal-instructions">
                  <h3>📱 Android ({platform.browserName}):</h3>
                  <ol>
                    <li>Al pulsar el botón se abrirán los <strong>Ajustes de ubicación</strong></li>
                    <li>Activa la <strong>Ubicación / GPS</strong> si está desactivada</li>
                    <li>Si ya está activada, vuelve al navegador</li>
                    <li>Pulsa en el <strong>candado 🔒</strong> de la barra de direcciones</li>
                    <li>Busca <strong>"Ubicación"</strong> → cambia a <strong>"Permitir"</strong></li>
                    <li>Pulsa <strong>"Reintentar"</strong> abajo</li>
                  </ol>
                </div>
                <div className="gps-modal-tip">
                  <strong>💡 Modo ahorro de batería:</strong> Si tienes el modo ahorro activado, puede bloquear el GPS.
                  Desactívalo temporalmente en <em>Ajustes → Batería → Ahorro de energía</em>
                </div>
              </>
            )}

            {/* ESCRITORIO */}
            {!platform.isIOS && !platform.isAndroid && (
              <div className="gps-modal-instructions">
                <h3>💻 Ordenador ({platform.browserName}):</h3>
                <ol>
                  <li>Busca el <strong>icono de candado 🔒</strong> en la barra de direcciones</li>
                  <li>Pulsa en él y busca <strong>"Ubicación"</strong></li>
                  <li>Cámbialo a <strong>"Permitir"</strong></li>
                  <li>Recarga la página</li>
                </ol>
              </div>
            )}

            <div className="gps-modal-actions">
              <button className="gps-modal-btn primary" onClick={() => {
                setShowGeoDeniedModal(false);
                // Forzar re-check del permiso antes de reintentar
                if (navigator.permissions) {
                  navigator.permissions.query({ name: 'geolocation' }).then(result => {
                    setGeoPermiso(result.state);
                    if (result.state === 'granted') {
                      // ¡El usuario ya lo activó en ajustes! Fichar directamente
                      ficharConGPS();
                    } else if (result.state === 'denied') {
                      // Sigue denegado - intentar de todas formas por si el navegador lo permite
                      setGeoPermiso('unknown');
                      solicitarPermisoGeo();
                    } else {
                      // Estado 'prompt' - mostrar modal informativo
                      setShowGeoModal(true);
                    }
                  }).catch(() => {
                    // iOS Safari - intentar directamente
                    setGeoPermiso('unknown');
                    solicitarPermisoGeo();
                  });
                } else {
                  // Sin Permissions API - intentar directamente
                  setGeoPermiso('unknown');
                  solicitarPermisoGeo();
                }
              }}>
                🔄 Reintentar
              </button>
              <button className="gps-modal-btn secondary" onClick={() => setShowGeoDeniedModal(false)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* GPS Permission banner (subtle, non-blocking) */}
      {!isQrMode && geoPermiso === 'denied' && !showGeoDeniedModal && (
        <div className="gps-perm-banner denied" onClick={() => setShowGeoDeniedModal(true)} style={{cursor: 'pointer'}}>
          🔒 GPS bloqueado. Toca aquí para ver cómo activarlo.
        </div>
      )}

      {/* ===== TOP: Avatar + Theme toggle + Greeting ===== */}
      <div className="gps-header">
        <div className="gps-header-top">
          <div className="gps-avatar">
            <span>{getInitials(nombre)}</span>
          </div>
          <button className="gps-theme-toggle" onClick={toggleTheme} title={darkMode ? 'Modo claro' : 'Modo oscuro'}>
            {darkMode ? '☀️' : '🌙'}
          </button>
        </div>
        <h1 className="gps-greeting">{getGreeting()}, {firstNameCapitalized}</h1>
        <p className="gps-date">{formatDateFull()}</p>
        <p className="gps-clock">{clockTime.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</p>
      </div>

      {/* ===== TIMER + PROGRESS ===== */}
      <div className="gps-timer-section">
        <div className="gps-status-icons">
          <div className={`gps-status-icon ${trabajando ? 'working' : 'idle'}`}>
            {trabajando ? '✓' : '○'}
          </div>
          <span className="gps-status-text">
            {trabajando
              ? 'Trabajando'
              : (turnoHoy
                  ? `Turno: ${turnoNombre || turnoHoy}`
                  : 'Sin turno activo')}
          </span>
        </div>

        <div className="gps-timer-display">
          <span className="gps-timer-value">{formatTime(tiempoHoy)}</span>
          <span className="gps-timer-label">de {jornadaHoras}h programadas</span>
        </div>

        <div className="gps-progress-container">
          <div className={`gps-progress-bar ${cercaFinal ? 'rainbow' : ''} ${completado ? 'completed' : ''}`}
               style={{ width: `${progreso * 100}%` }}>
          </div>
        </div>

        {dashboard?.entrada_turno && (
          <p className="gps-entry-time">Entrada: {dashboard.entrada_turno.substring(0, 5)}</p>
        )}
      </div>

      {/* ===== BIG FICHAR BUTTON ===== */}
      <div className="gps-fichar-section">
        <div className="gps-pulse-container">
          <div className="gps-pulse-ring gps-pulse-ring-1"></div>
          <div className="gps-pulse-ring gps-pulse-ring-2"></div>
          <div className="gps-pulse-ring gps-pulse-ring-3"></div>
          <button
            className={`gps-fichar-btn ${(isQrMode ? qrScanning : geoFichando) ? 'loading' : ''} ${tipo === 'salida' ? 'salida' : 'entrada'}`}
            onClick={isQrMode ? onQrScan : ficharConGPS}
            disabled={(isQrMode ? qrScanning : geoFichando) || (!isQrMode && cooldownRemaining > 0)}
          >
            <span className="gps-fichar-icon">
              {isQrMode ? (qrScanning ? '⌛' : '▣') : (geoFichando ? '⏳' : '⏱️')}
            </span>
            <span className="gps-fichar-text">
              {isQrMode ? (qrScanning ? 'Escaneando...' : 'Escanear QR') : (geoFichando ? 'Localizando...' : 'Fichar')}
            </span>
            <span className="gps-fichar-tipo">{tipo === 'salida' ? 'Salida' : 'Entrada'}</span>
          </button>
        </div>

        {(isQrMode ? (qrAdvertencia || qrMensaje) : geoMensaje) && (
          <div className={`gps-mensaje ${
            isQrMode && qrAdvertencia
              ? 'warn'
              : (isQrMode ? qrMensaje : geoMensaje).includes('✅') ||
                (isQrMode ? qrMensaje : geoMensaje).toLowerCase().includes('correctamente')
                ? 'ok'
                : (isQrMode ? qrMensaje : geoMensaje).includes('⚠️')
                  ? 'warn'
                  : /(error|no válido|denegado|bloqueado)/i.test(isQrMode ? qrMensaje : geoMensaje)
                    ? 'error'
                    : 'info'
          }`}>
            {isQrMode ? (qrAdvertencia || qrMensaje) : geoMensaje}
          </div>
        )}
      </div>

      {/* ===== SECTIONS NAV ===== */}
      <div className="gps-sections-nav">
        <button className={`gps-section-btn ${activeSection === 'inicio' ? 'active' : ''}`}
                onClick={() => setActiveSection('inicio')}>
          🏠 Inicio
        </button>
        <button className={`gps-section-btn ${activeSection === 'calendario' ? 'active' : ''}`}
                onClick={() => setActiveSection('calendario')}>
          📅 Calendario
        </button>
        <button className={`gps-section-btn ${activeSection === 'tiempo' ? 'active' : ''}`}
                onClick={() => setActiveSection('tiempo')}>
          ⏱️ Tiempo
        </button>
      </div>

      {/* ===== SECTIONS CONTENT ===== */}
      {activeSection === 'inicio' && (
        <div className="gps-section-content">
          {/* Today's fichajes */}
          <div className="gps-card">
            <h3 className="gps-card-title">📋 Fichajes de hoy</h3>
            {(!dashboard?.fichajes_hoy || dashboard.fichajes_hoy.length === 0) ? (
              <p className="gps-card-empty">No hay fichajes registrados hoy</p>
            ) : (
              <div className="gps-fichajes-list">
                {dashboard.fichajes_hoy.map((f, i) => (
                  <div key={i} className={`gps-fichaje-item ${f.tipo}`}>
                    <span className="gps-fichaje-tipo">{f.tipo === 'entrada' ? '🟢' : '🔴'} {f.tipo}</span>
                    <span className="gps-fichaje-hora">{f.hora?.substring(0, 8)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Quick week view */}
          <div className="gps-card">
            <h3 className="gps-card-title">📊 Esta semana</h3>
            <div className="gps-week-bars">
              {semanaData.map((d, i) => {
                const pct = maxHorasSemana > 0 ? (d.horas_visibles / maxHorasSemana) * 100 : 0;
                const isToday = d.fecha === new Date().toISOString().split('T')[0];
                return (
                  <div key={i} className={`gps-week-col ${isToday ? 'today' : ''}`}>
                    <div className="gps-week-bar-wrapper">
                      <div className="gps-week-bar" style={{ height: `${pct}%` }}>
                        {d.horas_visibles > 0 && <span className="gps-week-hours">{d.horas_visibles.toFixed(1)}</span>}
                      </div>
                    </div>
                    <span className="gps-week-label">{d.dia_semana}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {activeSection === 'calendario' && (
        <div className="gps-section-content">
          <div className="gps-card">
            <div className="gps-cal-header">
              <button className="gps-cal-nav" onClick={() => {
                if (calMonth === 1) { setCalMonth(12); setCalYear(y => y - 1); }
                else setCalMonth(m => m - 1);
              }}>‹</button>
              <h3 className="gps-cal-title">{MESES[calMonth - 1]} {calYear}</h3>
              <button className="gps-cal-nav" onClick={() => {
                if (calMonth === 12) { setCalMonth(1); setCalYear(y => y + 1); }
                else setCalMonth(m => m + 1);
              }}>›</button>
            </div>

            <div className="gps-cal-grid">
              {DIAS_SEMANA_CORTO.map(d => (
                <div key={d} className="gps-cal-weekday">{d}</div>
              ))}
              {Array.from({ length: primerDiaSemana }, (_, i) => (
                <div key={`e${i}`} className="gps-cal-empty"></div>
              ))}
              {Array.from({ length: diasDelMes }, (_, i) => {
                const dia = i + 1;
                const fechaStr = `${calYear}-${String(calMonth).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
                const data = calData[fechaStr];
                const isToday = fechaStr === new Date().toISOString().split('T')[0];
                const hasWorked = data && data.horas_visibles > 0;
                const hasSchedule = Boolean(data?.turno);
                const isRest = data?.turno && data.es_laborable === false;
                return (
                  <div
                    key={dia}
                    className={`gps-cal-day ${isToday ? 'today' : ''} ${hasWorked ? 'worked' : ''} ${hasSchedule ? 'scheduled' : ''} ${isRest ? 'rest' : ''} ${selectedDay === fechaStr ? 'selected' : ''}`}
                    onClick={() => setSelectedDay(selectedDay === fechaStr ? null : fechaStr)}
                  >
                    <span className="gps-cal-num">{dia}</span>
                    {hasSchedule && <span className="gps-cal-shift">{data.turno}</span>}
                    {hasWorked && <span className="gps-cal-dot"></span>}
                  </div>
                );
              })}
            </div>

            {selectedDay && calData[selectedDay] && (
              <div className="gps-cal-detail">
                <p><strong>📅 {selectedDay}</strong></p>
                {calData[selectedDay].turno && (
                  <p>🗓️ Cuadrante: <strong>{calData[selectedDay].turno_nombre || calData[selectedDay].turno}</strong> ({calData[selectedDay].turno})</p>
                )}
                <p>⏱️ Horas trabajadas: <strong>{calData[selectedDay].horas_visibles.toFixed(2)}h</strong></p>
                <p>📝 Fichajes: {calData[selectedDay].fichajes}</p>
                {(calData[selectedDay].fichajes_detalle || []).map((fichaje, index) => (
                  <p key={`${fichaje.tipo}-${fichaje.hora}-${index}`}>
                    {fichaje.tipo === 'entrada' ? '🟢' : '🔴'} {fichaje.tipo}: {fichaje.hora}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {activeSection === 'tiempo' && (
        <div className="gps-section-content">
          {/* Detailed time stats */}
          <div className="gps-card">
            <h3 className="gps-card-title">⏱️ Resumen de tiempo</h3>
            <div className="gps-time-stats">
              <div className="gps-stat-item">
                <span className="gps-stat-value">{formatTimeShort(tiempoHoy)}</span>
                <span className="gps-stat-label">Hoy</span>
              </div>
              <div className="gps-stat-item">
                <span className="gps-stat-value">{semanaData.reduce((s, d) => s + d.horas_visibles, 0).toFixed(1)}h</span>
                <span className="gps-stat-label">Esta semana</span>
              </div>
              <div className="gps-stat-item">
                <span className="gps-stat-value">
                  {horasMesVisibles.toFixed(1)}h
                </span>
                <span className="gps-stat-label">{MESES[calMonth - 1]}</span>
              </div>
            </div>
          </div>

          {/* Weekly chart */}
          <div className="gps-card">
            <h3 className="gps-card-title">📊 Gráfica semanal</h3>
            <div className="gps-chart-container">
              {semanaData.map((d, i) => {
                const pct = maxHorasSemana > 0 ? (d.horas_visibles / maxHorasSemana) * 100 : 0;
                const isToday = d.fecha === new Date().toISOString().split('T')[0];
                return (
                  <div key={i} className="gps-chart-col">
                    <div className="gps-chart-value">{d.horas_visibles > 0 ? `${d.horas_visibles.toFixed(1)}h` : '-'}</div>
                    <div className="gps-chart-bar-wrap">
                      <div className={`gps-chart-bar ${isToday ? 'today' : ''}`} style={{ height: `${pct}%` }}></div>
                    </div>
                    <div className={`gps-chart-label ${isToday ? 'today' : ''}`}>{d.dia_semana}</div>
                    <div className="gps-chart-date">{d.fecha.substring(8, 10)}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Monthly days summary */}
          <div className="gps-card">
            <h3 className="gps-card-title">📅 Días trabajados en {MESES[calMonth - 1]}</h3>
            <div className="gps-days-summary">
              <div className="gps-days-count">
                <span className="gps-days-number">{(dashboard?.calendario || []).filter(d => d.horas > 0).length}</span>
                <span className="gps-days-label">días trabajados</span>
              </div>
              <div className="gps-days-count">
                <span className="gps-days-number">{(dashboard?.calendario || []).filter(d => d.horas >= jornadaHoras).length}</span>
                <span className="gps-days-label">jornadas completas</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== DAY SLIDER ===== */}
      <div className="gps-card gps-slider-card">
        <h3 className="gps-card-title">📆 Historial reciente</h3>
        <div className="gps-day-slider">
          {[...Array(14)].map((_, i) => {
            const d = new Date();
            d.setDate(d.getDate() - (13 - i));
            const fechaStr = d.toISOString().split('T')[0];
            const data = calData[fechaStr];
            const isToday = i === 13;
            return (
              <div key={i} className={`gps-slider-day ${isToday ? 'today' : ''} ${data && data.horas > 0 ? 'worked' : ''}`}
                   onClick={() => setSelectedDay(selectedDay === fechaStr ? null : fechaStr)}
                   title={`${fechaStr}: ${data ? data.horas_visibles.toFixed(1) + 'h' : 'Sin datos'}`}>
                <span className="gps-slider-weekday">{DIAS_SEMANA_CORTO[d.getDay() === 0 ? 6 : d.getDay() - 1]}</span>
                <span className="gps-slider-num">{d.getDate()}</span>
                {data && data.horas_visibles > 0 && (
                  <span className="gps-slider-hours">{data.horas_visibles.toFixed(1)}h</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
